import CobrancaCondominialPrevia from './components/pages/UnidadesCondominiais/CobrancaPrevia';
import { Route, Routes } from 'react-router-dom';

/* components */
import Header from './components/layout/Header';
import Navbar from './components/layout/Navbar';
import Container from './components/layout/Container';
import Footer from './components/layout/Footer';
import Message from './components/layout/Message';

/*  pages */
import Home from './components/pages/Home';
import Login from './components/pages/Auth/Login';

/* Administração */
import Ambiente from './components/pages/Ambiente/Index';
import AmbienteCreateOrEdit from './components/pages/Ambiente/CreateOrEdit';

import Banco from './components/pages/Bancos/Index';
import BancoCreateOrEdit from './components/pages/Bancos/CreateOrEdit';

import CEST from './components/pages/CEST/Index';
import CESTCreateOrEdit from './components/pages/CEST/CreateOrEdit';

import CFOP from './components/pages/CFOP/Index';
import CFOPCreateOrEdit from './components/pages/CFOP/CreateOrEdit';

import Homologation from './components/pages/Homologation/Index';
import HomologationCreateOrEdit from './components/pages/Homologation/CreateOrEdit';

import Documento from './components/pages/Documento/Index';
import DocumentoCreateOrEdit from './components/pages/Documento/CreateOrEdit';
//Estado
import Uf from './components/pages/UF/Index';
import UfEdit from './components/pages/UF/Edit';

import Menu from './components/pages/Menus/Index';
import MenuCreateOrEdit from './components/pages/Menus/CreateOrEdit';

import MenuSub from './components/pages/MenusSub/Index';
import MenuSubCreateOrEdit from './components/pages/MenusSub/CreateOrEdit';

import Municipio from './components/pages/Municipios/Index';
import MunicipioCreateOrEdit from './components/pages/Municipios/CreateOrEdit';

import NCM from './components/pages/NCM/Index';
import NCMCreateOrEdit from './components/pages/NCM/CreateOrEdit';

import Operacao from './components/pages/Operacao/Index';
import OperacaoCreateOrEdit from './components/pages/Operacao/CreateOrEdit';

import Pais from './components/pages/Pais/Index';
import PaisCreateOrEdit from './components/pages/Pais/CreateOrEdit';

import Situacao from './components/pages/Situacao/Index';
import SituacaoCreateOrEdit from './components/pages/Situacao/CreateOrEdit';

import UsuarioPermitido from './components/pages/UsuarioPermitido/Index';
import UsuarioPermitidoCreateOrEdit from './components/pages/UsuarioPermitido/CreateOrEdit';

/* Administrativo */
import ArquivoDocumento from './components/pages/ArquivoDocumento/Index';
import ArquivoDocumentoCreateOrEdit from './components/pages/ArquivoDocumento/CreateOrEdit';
import ArquivoDocumentoTipo from './components/pages/ArquivoDocumentoTipo/Index';
import ArquivoDocumentoTipoCreateOrEdit from './components/pages/ArquivoDocumentoTipo/CreateOrEdit';
import CensoPopulacional from './components/pages/CensoPopulacional/Index';
import Equipe from './components/pages/Equipes/Index';
import EquipeCreateOrEdit from './components/pages/Equipes/CreateOrEdit';
import EleicaoIndex from './components/pages/Eleicao/Index';
import EleicaoCreateOrEdit from './components/pages/Eleicao/CreateOrEdit';
import Indexador from './components/pages/Indexador/Index';
import IndexadorCreateOrEdit from './components/pages/Indexador/CreateOrEdit';

import Pocos from './components/pages/Pocos/Index';

import Plantao from './components/pages/Plantao/Index';
import PlantaoCreateOrEdit from './components/pages/Plantao/CreateOrEdit';
import PlantaoTipo from './components/pages/PlantaoTipo/Index';
import PlantaoTipoCreateOrEdit from './components/pages/PlantaoTipo/CreateOrEdit';

/* Cadastros */
import Anilox from './components/pages/Anilox/Index';
import AniloxCreateOrEdit from './components/pages/Anilox/CreateOrEdit';

import Assinaturas from './components/pages/Assinaturas/Index';
import AssinaturasCreateOrEdit from './components/pages/Assinaturas/CreateOrEdit';

import Associados from './components/pages/AssociadoVinculos/Index';
import AssociadosCreateOrEdit from './components/pages/AssociadoVinculos/CreateOrEdit';

import Cargo from './components/pages/Cargo/Index';
import CargoCreateOrEdit from './components/pages/Cargo/CreateOrEdit';

import Cilindros from './components/pages/Cilindros/Index';
import CilindrosCreateOrEdit from './components/pages/Cilindros/CreateOrEdit';

import Cores from './components/pages/Cores/Index';
import CoresCreateOrEdit from './components/pages/Cores/CreateOrEdit';

import Embalagem from './components/pages/Embalagens/Index';
import EmbalagemCreateOrEdit from './components/pages/Embalagens/CreateOrEdit';

import Grupo from './components/pages/Grupos/Index';
import GrupoCreateOrEdit from './components/pages/Grupos/CreateOrEdit';

import Maquinas from './components/pages/Maquinas/Index';
import MaquinasCreateOrEdit from './components/pages/Maquinas/CreateOrEdit';

import Nivel from './components/pages/Nivel/Index';
import NivelCreateOrEdit from './components/pages/Nivel/CreateOrEdit';

import Pessoa from './components/pages/Pessoas/Index';
import PessoaCreateOrEdit from './components/pages/Pessoas/CreateOrEdit';

import Produto from './components/pages/Produto/Index';
import ProdutoDuplicidades from './components/pages/Produto/duplicidades/Index';
import ProdutoCreateOrEdit from './components/pages/Produto/CreateOrEdit';

import Setor from './components/pages/Setor/Index';
import SetorCreateOrEdit from './components/pages/Setor/CreateOrEdit';

import TabelaPreco from './components/pages/tabelaPrecos/Index';
import TabelaPrecoCreateOrEdit from './components/pages/tabelaPrecos/CreateOrEdit';

import Tributacao from './components/pages/Tributacao/Index';
import TributacaoCreateOrEdit from './components/pages/Tributacao/CreateOrEdit';

import Unidades from './components/pages/Unidades/Index';
import UnidadeCreateOrEdit from './components/pages/Unidades/CreateOrEdit';

import UnidadeCondominial from './components/pages/UnidadesCondominiais/Index';
import UnidadeCondominialCreateOrEdit from './components/pages/UnidadesCondominiais/CreateOrEdit';

import UnidadeCondominialPessoas from './components/pages/UnidadeCondominialPessoas/Index';
import UnidadeCondominialPessoasCreateOrEdit from './components/pages/UnidadeCondominialPessoas/CreateOrEdit';

import UnidadeCondominialProdutos from './components/pages/UnidadeCondominialProdutos/Index';
import UnidadeCondominialProdutosCreateOrEdit from './components/pages/UnidadeCondominialProdutos/CreateOrEdit';

import Vacina from './components/pages/Vacina/Index';
import VacinaCreateOrEdit from './components/pages/Vacina/CreateOrEdit';

/* Contabil */
import FiscalPerfil from './components/pages/FiscalPerfis/Index';
import FiscalPerfilCreateOrEdit from './components/pages/FiscalPerfis/CreateOrEdit';

import FiscalXmlObservacoes from './components/pages/FiscalXmlObservacoes/Index';

/* Logística */
import Almoxarifado from './components/pages/Almoxarifado/Index';
import AlmoxarifadoCreateOrEdit from './components/pages/Almoxarifado/CreateOrEdit';
import AlmoxarifadoMovimento from './components/pages/AlmoxarifadoMovimento/Index';
import AlmoxarifadoMovimentoCreateOrEdit from './components/pages/AlmoxarifadoMovimento/CreateOrEdit';

/* Financeiro */
import ArquivoRetorno from './components/pages/ArquivoRetorno/Index';
import Forma from './components/pages/Forma/Index';
import FormaCreateOrEdit from './components/pages/Forma/CreateOrEdit';
import Prazo from './components/pages/Prazo/Index';
import PrazoCreateOrEdit from './components/pages/Prazo/CreateOrEdit';

/* Faturamento*/
import Balancete from './components/pages/Balancetes/Index';
import CentroCusto from './components/pages/CentroCustos/Index';
import CentroCustoCreateOrEdit from './components/pages/CentroCustos/CreateOrEdit';
import CentroCustoLimite from './components/pages/CentroCustoLimites/Index';
import CentroCustoLimiteCreateOrEdit from './components/pages/CentroCustoLimites/CreateOrEdit';
import CentroCustoLimiteDuplicar from './components/pages/CentroCustoLimites/Duplicar';

import Conta from './components/pages/Contas/Index';
import ContaCreateOrEdit from './components/pages/Contas/CreateOrEdit';
import CPR from './components/pages/Lancamentos/Index';
import CPRCreateOrEdit from './components/pages/Lancamentos/CreateOrEdit';

import Extrato from './components/pages/lancamentoContas/Index';
import ExtratoCreateOrEdit from './components/pages/lancamentoContas/CreateOrEdit';

/* Frota */
import ProdutoModelo from './components/pages/ProdutoModelo/Index';
import ProdutoModeloCreateOrEdit from './components/pages/ProdutoModelo/CreateOrEdit';
import MapaAbastecimento from './components/pages/MapaAbastecimento/Index';
import MapaAbastecimentoCreateOrEdit from './components/pages/MapaAbastecimento/CreateOrEdit';

/* Movimentos */
import Caixa from './components/pages/Caixa/Index';
import CaixaCreateOrEdit from './components/pages/Caixa/CreateOrEdit';

import Movimento from './components/pages/Movimento/Index';
import MovimentoCreateOrEdit from './components/pages/Movimento/CreateOrEdit';

/* Parametros */
import Ajuda from './components/pages/Ajuda/Index';
import AjudaCreateOrEdit from './components/pages/Ajuda/CreateOrEdit';

import IntegracaoClientes from './components/pages/IntegracaoClientes/Index';
import IntegracaoClientesCreateOrEdit from './components/pages/IntegracaoClientes/CreateOrEdit';

import Empresa from './components/pages/Empresas/Index';
import EmpresaCreateOrEdit from './components/pages/Empresas/CreateOrEdit';
import ParametroOperacoes from './components/pages/ParametroOperacoes/Index';
import ParametroOperacoesCreateOrEdit from './components/pages/ParametroOperacoes/CreateOrEdit';
import Parametro from './components/pages/Parametros/Index';
import ParametroCreateOrEdit from './components/pages/Parametros/CreateOrEdit';
import PessoaEmpresa from './components/pages/PessoaEmpresa/Index';
import PessoaEmpresaCreateOrEdit from './components/pages/PessoaEmpresa/CreateOrEdit';
import Permissoes from './components/pages/Permissoes/Index';
import PermissoesCreateOrEdit from './components/pages/Permissoes/CreateOrEdit';

/* Recursos Humanos */
import RH from './components/pages/RH/Index';
import RHCreateOrEdit from './components/pages/RH/CreateOrEdit';
import RHCreateOrEditComprovante from './components/pages/RH/CreateOrEditComprovante';

import PerfisPermissao from './components/pages/PerfisPermissao/Index';

function App() {
    return (
        <>
            <Header />
            <Navbar />
            <Message />
            <Container>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/Auth" element={<Login />} />

                    {/* Administração */}
                    <Route path="/Ambiente" element={<Ambiente />} />
                    <Route path="/Ambiente/CreateOrEdit" element={<AmbienteCreateOrEdit />} />

                    <Route path="/Bancos" element={<Banco />} />
                    <Route path="/Bancos/CreateOrEdit" element={<BancoCreateOrEdit />} />

                    <Route path="/CEST" element={<CEST />} />
                    <Route path="/CEST/CreateOrEdit" element={<CESTCreateOrEdit />} />

                    <Route path="/CFOP" element={<CFOP />} />
                    <Route path="/CFOP/CreateOrEdit" element={<CFOPCreateOrEdit />} />

                    <Route path="/Homologation" element={<Homologation />} />
                    <Route path="/Homologation/CreateOrEdit" element={<HomologationCreateOrEdit />} />

                    <Route path="/Documento" element={<Documento />} />
                    <Route path="/Documento/CreateOrEdit" element={<DocumentoCreateOrEdit />} />

                    <Route path="/Uf" element={<Uf />} />
                    <Route path="Uf/Edit/:uuid" element={<UfEdit />} />
                    <Route path="/Uf/CreateOrEdit" element={<DocumentoCreateOrEdit />} />

                    <Route path="/Menu" element={<Menu />} />
                    <Route path="/Menu/CreateOrEdit" element={<MenuCreateOrEdit />} />

                    <Route path="/MenuSub" element={<MenuSub />} />
                    <Route path="/MenuSub/CreateOrEdit" element={<MenuSubCreateOrEdit />} />

                    <Route path="/Municipio" element={<Municipio />} />
                    <Route path="/Municipio/CreateOrEdit" element={<MunicipioCreateOrEdit />} />

                    <Route path="/NCM" element={<NCM />} />
                    <Route path="/NCM/CreateOrEdit" element={<NCMCreateOrEdit />} />

                    <Route path="/Operacao" element={<Operacao />} />
                    <Route path="/Operacao/CreateOrEdit" element={<OperacaoCreateOrEdit />} />

                    <Route path="/Pais" element={<Pais />} />
                    <Route path="/Pais/CreateOrEdit" element={<PaisCreateOrEdit />} />

                    <Route path="/Situacao" element={<Situacao />} />
                    <Route path="/Situacao/CreateOrEdit" element={<SituacaoCreateOrEdit />} />

                    <Route path="/UsuarioPermitido" element={<UsuarioPermitido />} />
                    <Route path="/UsuarioPermitido/CreateOrEdit" element={<UsuarioPermitidoCreateOrEdit />} />

                    {/* Administrativo */}
                    <Route path="/ArquivoDocumento" element={<ArquivoDocumento />} />
                    <Route path="/ArquivoDocumento/CreateOrEdit" element={<ArquivoDocumentoCreateOrEdit />} />
                    <Route path="/ArquivoDocumentoTipo" element={<ArquivoDocumentoTipo />} />
                    <Route path="/ArquivoDocumentoTipo/CreateOrEdit" element={<ArquivoDocumentoTipoCreateOrEdit />} />
                    <Route path="/CensoPopulacional" element={<CensoPopulacional />} />
                    <Route path="/Equipes/CreateOrEdit" element={<EquipeCreateOrEdit />} />
                    <Route path="/Equipes" element={<Equipe />} />
                    <Route path="/Eleicao" element={<EleicaoIndex />} />
                    <Route path="/Eleicao/CreateOrEdit" element={<EleicaoCreateOrEdit />} />
                    <Route path="/Indexador" element={<Indexador />} />
                    <Route path="/Indexador/CreateOrEdit" element={<IndexadorCreateOrEdit />} />

                    <Route path="/Pocos" element={<Pocos />} />

                    <Route path="/Plantao" element={<Plantao />} />
                    <Route path="/Plantao/CreateOrEdit" element={<PlantaoCreateOrEdit />} />
                    <Route path="/PlantaoTipo" element={<PlantaoTipo />} />
                    <Route path="/PlantaoTipo/CreateOrEdit" element={<PlantaoTipoCreateOrEdit />} />

                    {/* Cadastros */}
                    <Route path="/Anilox" element={<Anilox />} />
                    <Route path="/Anilox/CreateOrEdit" element={<AniloxCreateOrEdit />} />

                    <Route path="/Assinaturas" element={<Assinaturas />} />
                    <Route path="/Assinaturas/CreateOrEdit" element={<AssinaturasCreateOrEdit />} />

                    <Route path="/AssociadoVinculos" element={<Associados />} />
                    <Route path="/AssociadoVinculos/CreateOrEdit" element={<AssociadosCreateOrEdit />} />

                    <Route path="/Cargo" element={<Cargo />} />
                    <Route path="/Cargo/CreateOrEdit" element={<CargoCreateOrEdit />} />
                    <Route path="/Cilindros" element={<Cilindros />} />
                    <Route path="/Cilindros/CreateOrEdit" element={<CilindrosCreateOrEdit />} />
                    <Route path="/Cores" element={<Cores />} />
                    <Route path="/Cores/CreateOrEdit" element={<CoresCreateOrEdit />} />

                    <Route path="/Embalagens" element={<Embalagem />} />
                    <Route path="/Embalagens/CreateOrEdit" element={<EmbalagemCreateOrEdit />} />

                    <Route path="/Grupos/CreateOrEdit" element={<GrupoCreateOrEdit />} />
                    <Route path="/Grupos" element={<Grupo />} />

                    <Route path="/Maquinas" element={<Maquinas />} />
                    <Route path="/Maquinas/CreateOrEdit" element={<MaquinasCreateOrEdit />} />
                    <Route path="/Nivel" element={<Nivel />} />
                    <Route path="/Nivel/CreateOrEdit" element={<NivelCreateOrEdit />} />
                    <Route path="/Pessoa" element={<Pessoa />} />
                    <Route path="/Pessoa/CreateOrEdit" element={<PessoaCreateOrEdit />} />
                    <Route path="/Produtos" element={<Produto />} />
                    <Route path="/Produtos/Duplicidades" element={<ProdutoDuplicidades />} />
                    <Route path="/Produtos/CreateOrEdit" element={<ProdutoCreateOrEdit />} />
                    <Route path="/Setor" element={<Setor />} />
                    <Route path="/Setor/CreateOrEdit" element={<SetorCreateOrEdit />} />
                    <Route path="/tabelaPrecos" element={<TabelaPreco />} />
                    <Route path="/tabelaPrecos/CreateOrEdit" element={<TabelaPrecoCreateOrEdit />} />
                    <Route path="/Tributacao" element={<Tributacao />} />
                    <Route path="/Tributacao/CreateOrEdit" element={<TributacaoCreateOrEdit />} />
                    <Route path="/Unidades" element={<Unidades />} />
                    <Route path="/Unidades/CreateOrEdit" element={<UnidadeCreateOrEdit />} />

                    <Route path="/UnidadesCondominiais/Cobranca" element={<CobrancaCondominialPrevia />} />
                    <Route path="/UnidadesCondominiais" element={<UnidadeCondominial />} />
                    <Route path="/UnidadesCondominiais/CreateOrEdit" element={<UnidadeCondominialCreateOrEdit />} />

                    <Route path="/UnidadeCondominialPessoas" element={<UnidadeCondominialPessoas />} />
                    <Route path="/UnidadeCondominialPessoas/CreateOrEdit" element={<UnidadeCondominialPessoasCreateOrEdit />} />

                    <Route path="/UnidadeCondominialProdutos" element={<UnidadeCondominialProdutos />} />
                    <Route path="/UnidadeCondominialProdutos/CreateOrEdit" element={<UnidadeCondominialProdutosCreateOrEdit />} />

                    <Route path="/Vacina" element={<Vacina />} />
                    <Route path="/Vacina/CreateOrEdit" element={<VacinaCreateOrEdit />} />

                    {/* Contábil */}
                    <Route path="/FiscalPerfis" element={<FiscalPerfil />} />
                    <Route path="/FiscalPerfis/CreateOrEdit" element={<FiscalPerfilCreateOrEdit />} />

                    <Route path="/FiscalXmlObservacoes" element={<FiscalXmlObservacoes />} />

                    {/* Logistica */}
                    <Route path="/Almoxarifado" element={<Almoxarifado />} />
                    <Route path="/Almoxarifado/CreateOrEdit" element={<AlmoxarifadoCreateOrEdit />} />
                    <Route path="/AlmoxarifadoMovimento" element={<AlmoxarifadoMovimento />} />
                    <Route path="/AlmoxarifadoMovimento/CreateOrEdit" element={<AlmoxarifadoMovimentoCreateOrEdit />} />

                    {/* Faturamento */}

                    {/* Financeiro */}
                    <Route path="/arquivoRetorno" element={<ArquivoRetorno />} />
                    <Route path="/Balancete" element={<Balancete />} />

                    <Route path="/CentroCustos" element={<CentroCusto />} />
                    <Route path="/CentroCustos/CreateOrEdit" element={<CentroCustoCreateOrEdit />} />
                    <Route path="/CentroCustoLimites" element={<CentroCustoLimite />} />
                    <Route path="/CentroCustoLimites/CreateOrEdit" element={<CentroCustoLimiteCreateOrEdit />} />

                    <Route path="/CentroCustoLimites/Duplicar" element={<CentroCustoLimiteDuplicar />} />
                    <Route path="/Contas" element={<Conta />} />
                    <Route path="/Contas/CreateOrEdit" element={<ContaCreateOrEdit />} />
                    <Route path="/lancamentoContas" element={<Extrato />} />
                    <Route path="/lancamentoContas/CreateOrEdit" element={<ExtratoCreateOrEdit />} />
                    <Route path="/Forma" element={<Forma />} />
                    <Route path="/Forma/CreateOrEdit" element={<FormaCreateOrEdit />} />
                    <Route path="/Prazo" element={<Prazo />} />
                    <Route path="/Prazo/CreateOrEdit" element={<PrazoCreateOrEdit />} />
                    <Route path="/Lancamentos" element={<CPR />} />
                    <Route path="/Lancamentos/CreateOrEdit" element={<CPRCreateOrEdit />} />

                    {/* Frota */}
                    <Route path="/ProdutoModelo" element={<ProdutoModelo />} />
                    <Route path="/ProdutoModelo/CreateOrEdit" element={<ProdutoModeloCreateOrEdit />} />
                    <Route path="/MapaAbastecimento" element={<MapaAbastecimento />} />
                    <Route path="/MapaAbastecimento/CreateOrEdit" element={<MapaAbastecimentoCreateOrEdit />} />

                    {/* Movimentos */}
                    <Route path="/Caixa" element={<Caixa />} />
                    <Route path="/Caixa/CreateOrEdit" element={<CaixaCreateOrEdit />} />
                    <Route path="/Movimento" element={<Movimento />} />
                    <Route path="/Movimento/CreateOrEdit" element={<MovimentoCreateOrEdit />} />

                    {/* Parâmetros */}
                    <Route path="/Ajuda" element={<Ajuda />} />
                    <Route path="/Ajuda/CreateOrEdit" element={<AjudaCreateOrEdit />} />
                    <Route path="/IntegracaoClientes" element={<IntegracaoClientes />} />
                    <Route path="/IntegracaoClientes/CreateOrEdit" element={<IntegracaoClientesCreateOrEdit />} />
                    <Route path="/Empresa" element={<Empresa />} />
                    <Route path="/Empresa/CreateOrEdit" element={<EmpresaCreateOrEdit />} />
                    <Route path="/ParametroOperacoes" element={<ParametroOperacoes />} />
                    <Route path="/ParametroOperacoes/CreateOrEdit" element={<ParametroOperacoesCreateOrEdit />} />
                    <Route path="/Parametro" element={<Parametro />} />
                    <Route path="/Parametro/CreateOrEdit" element={<ParametroCreateOrEdit />} />
                    <Route path="/PerfisPermissao" element={<PerfisPermissao />} />
                    <Route path="/Permissoes" element={<Permissoes />} />
                    <Route path="/Permissoes/CreateOrEdit" element={<PermissoesCreateOrEdit />} />

                    <Route path="/PessoaEmpresa" element={<PessoaEmpresa />} />
                    <Route path="/PessoaEmpresa/CreateOrEdit" element={<PessoaEmpresaCreateOrEdit />} />

                    {/* Recursos Humanos*/}
                    <Route path="/RH" element={<RH />} />
                    <Route path="/RH/CreateOrEdit" element={<RHCreateOrEdit />} />
                    <Route path="/RH/CreateOrEditComprovante" element={<RHCreateOrEditComprovante />} />
                </Routes>
            </Container>
            <Footer />
        </>
    );
}

export default App;
